/**
 * Tonnie staff — a business admin of the Tonnie Internal tenant. The one rule
 * the operation's route guard and its sidebar item read (InOut plan §6, V24).
 * Both read the `user` of the app's `AuthContext`, whose tenant and role come
 * from the database membership (`/auth/me/portals`), never Clerk's cache;
 * the API enforces the same with `@RequireTonnieStaff()`, which is the real
 * boundary: this only decides what the portal offers.
 */
import { TONNIE_INTERNAL_TENANT_ID } from './feature-flags';

/** A member of the Tonnie Internal tenant (any role) — what Pool, Affiliates and Billing widen for. */
export function isTonnieInternal(user: { tenantId?: string | null } | null | undefined): boolean {
  return user?.tenantId === TONNIE_INTERNAL_TENANT_ID;
}

export function isTonnieStaff(
  user: { tenantId?: string | null; role?: string | null } | null | undefined
): boolean {
  return isTonnieInternal(user) && user?.role === 'business_admin';
}
